/**
 * Show Backdrop Action
 * Uses the existing runToggleBackdrop with action='show' and unique event ID targeting
 */

import { runBackdropToggle } from './runBackdropToggle.jsx';

export const runBackdropShow = async (data = {}) => {
  try {
    const { eventId, targetEventId, ...otherData } = data;

    // Use targetEventId as selector if provided, otherwise use eventId
    const selector = targetEventId ? `#${targetEventId}` : eventId ? `#${eventId}` : '.backdrop';

    return await runBackdropToggle({
      action: 'show',
      selector,
      ...otherData
    });
  } catch (error) {
    console.error('Show backdrop error:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export default runBackdropShow;
